import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import {
  ExpenseTypes,
  type ExpenseTypeEnum,
} from '../../entities/enums/ExpenseTypeEnum'

export const useFormatExpenseItemTypeLabel = () => {
  const intl = useProcurifyIntl()

  return (type: ExpenseTypeEnum): string => {
    switch (type) {
      case ExpenseTypes.OTHER:
        return intl.formatMessage(messages.expenseTypeOther)
      case ExpenseTypes.MEALS:
        return intl.formatMessage(messages.expenseTypeMeals)
      case ExpenseTypes.MILEAGE:
        return intl.formatMessage(messages.expenseTypeMileage)
      case ExpenseTypes.LABOUR:
        return intl.formatMessage(messages.expenseTypeLabour)
      case ExpenseTypes.AIRFARE:
        return intl.formatMessage(messages.expenseTypeAirfare)
      case ExpenseTypes.LODGING:
        return intl.formatMessage(messages.expenseTypeLodging)
    }
  }
}
